import { env } from "@/env";
import { focusRingInset, icons } from "@/ui";
import { addUtmParams, type UtmParams } from "@/utils/url";

type ExternalLinkProps = {
  text: string;
  link: string;
  utmParams?: UtmParams;
};

export const ExternalLink = ({ link, text, utmParams }: ExternalLinkProps) => {
  const linkWithUtmParams = addUtmParams(link, {
    utm_source: new URL(env.VITE_APP_URL).hostname,
    ...utmParams,
  });

  return (
    <a
      className={`group flex min-h-14 w-full items-center justify-between gap-4 rounded-card border-b border-line px-4 py-4 text-base transition-colors duration-200 hover:bg-surface-hover hover:text-accent sm:w-[278px] sm:border sm:px-5 ${focusRingInset}`}
      href={linkWithUtmParams}
      rel="noreferrer noopener"
      target="_blank"
    >
      <span className="underline underline-offset-4">{text}</span>

      <icons.ExternalLinkIcon
        aria-hidden="true"
        className="size-5 shrink-0 text-content-muted transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-accent"
      />
    </a>
  );
};
